module.exports = __webpack_public_path__ + "static/images/map/markers/arrived_destination_marker.png";